import { VALIDATION_LOCATION_COLORS, VALIDATION_SCENARIO_COLORS } from "consts";

export const scenarioColor = (scenario: string): string => VALIDATION_SCENARIO_COLORS[scenario] ?? "#6b7280";

export const locationColorMap = (locations: string[]): Record<string, string> =>
  Object.fromEntries(locations.map((location, index) => [location, VALIDATION_LOCATION_COLORS[index % VALIDATION_LOCATION_COLORS.length]!]));
